import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

export type LocationTabsStylesParams = {
  locationTabsRegularFont: StyleParamType.Font
  locationTabsRegularColor: StyleParamType.Color
  locationTabsSelectedFont: StyleParamType.Font
  locationTabsSelectedColor: StyleParamType.Color
  locationTabsRegularDividerColor: StyleParamType.Color
  locationTabsSelectedUnderlineColor: StyleParamType.Color
}

export const locationTabsStylesParams = createStylesParams<LocationTabsStylesParams>({
  locationTabsRegularFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  locationTabsRegularColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
  },
  locationTabsSelectedFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
  },
  locationTabsSelectedColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
  },
  locationTabsRegularDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.3),
  },
  locationTabsSelectedUnderlineColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
  },
})
